/** @format */

export function addCommas(num) {
    if (!num) return null;

    let isMoney = false;
    if (typeof num === 'string') isMoney = num.includes('$');

    // Convert num to string and split into integer and decimal parts
    const parts = String(num).replace('$', '').split('.');
    let integerPart = parts[0];
    const decimalPart = parts[1] ? '.' + parts[1] : '';

    // Add commas to integer part
    const integerLength = integerPart.length;
    if (integerLength > 3) {
        const commaCount = Math.floor((integerLength - 1) / 3);
        for (let i = 1; i <= commaCount; i++) {
            const index = integerLength - i * 3;
            integerPart = integerPart.slice(0, index) + ',' + integerPart.slice(index);
        }
    }

    // Concatenate integer and decimal parts
    let fullNumber = integerPart + decimalPart;
    fullNumber = isMoney ? `$${fullNumber}` : fullNumber;

    return fullNumber;
}
